// department cookie is set on
// -- 1. every page load
// -- 2. department change

import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants";
import { setDepartmentCookie } from "@ocm/services/departmentCookie";

export function init() {
	const departmentKey = window.recommendationData?.Recommendation?.pageData?.activeDepartment;
	// ocm-object.ts - department has often different conten as recommendations - department, and therefore connot be used here

	// set cookie on page load, uses ocm-object.js
	if (departmentKey && typeof departmentKey === "string") setDepartmentCookie(departmentKey);

	// subscribe to department change, e.g., used on lastStepPage
	OcmMessenger.subscribe(messengerPublicationTypes.DEPARTMENT_CHANGE, (data) => {
		const _departmentKey = data.data;
		if (_departmentKey) setDepartmentCookie(_departmentKey);
	});
}
